import React from 'react';

let _varCache = {};
let _instances = {};

export default class I18n {

    static getInstance(lang = 'en') {
        if (!_instances[lang]) {
            _instances[lang] = new I18n(lang);
        }
        return _instances[lang];
    }

    constructor(lang) {
        if (!!_instances[lang]) {
            throw "I18n class is a multiton";
        }
        this._lang = lang;
        this._getRootVar = this._getRootVar.bind(this);
        this._getLanguageVar = this._getLanguageVar.bind(this);
        this.getVar = this.getVar.bind(this);
        this.getString = this.getString.bind(this);
        this.getJsx = this.getJsx.bind(this);
    }

    get lang() {
        return this._lang;
    }

    _getRootVar() {
        try {
            return __I18N__;
        } catch(e) {
            return {};
        }
    }

    _getLanguageVar() {
        return !!this._getRootVar()[this.lang] ? this._getRootVar()[this.lang] : {};
    }

    getVar(varPath) {
        let pathComponents = varPath.split('::');
        let currentVar = this._getLanguageVar();
        for (let i = 0; i < pathComponents.length; i++) {
            currentVar = currentVar[pathComponents[i]];
            if (currentVar === undefined) {
                return `{${varPath}}`; //error
            }
        }
        return currentVar;
    }
    static getVar(varPath) {
        return I18n.getInstance().getVar(varPath);
    }

    getString(varPath, replaces = {}) {
        let cacheKey = `${this.lang}::${varPath}_${JSON.stringify(replaces)}`;
        if (!!_varCache[cacheKey]) {
            return _varCache[cacheKey];
        }
        let prepString = this.getVar(varPath);
        let finalString = prepString;
        for (let k in replaces) {
            finalString = finalString.replace(`{${k}}`, replaces[k]);
        }
        _varCache[cacheKey] = finalString;
        return finalString;
    }
    static getString(varPath, replaces = {}) {
        return I18n.getInstance().getString(varPath, replaces);
    }

    getFloat(varPath) {
        return parseFloat(this.getString(varPath));
    }
    static getFloat(varPath) {
        return I18n.getInstance().getFloat(varPath);
    }

    getJsx(varPath, replaces = {}) {
        //TODO: do not convert replaces to array
        let prepString = this.getVar(varPath);
        let stringParts = prepString.split(/\{.*?\}/);
        let replacesArr = Object.keys(replaces).map(function (k) {return replaces[k]}); //replaces to array
        let listOfSubElements = [];
        for (let i in stringParts) {
            let e = React.createElement('span', {key: `prt${i}`}, stringParts[i]);
            listOfSubElements.push(e);
            if (!!replacesArr[i]) {
                let r = React.cloneElement(replacesArr[i], {key: `replace${i}`});
                listOfSubElements.push(r);
            }
        }
        return React.createElement('span', null, listOfSubElements);
    }
    static getJsx(varPath, replaces = {}) {
        return I18n.getInstance().getJsx(varPath, replaces);
    }
}
